import {
  _COMMIT_LOG, SEARCH_POST_QUERY,
} from './actions.types'
import {
  SEARCH_SET_USE_CACHE, SEARCH_SET_ENABLED_FILTERS,
  SEARCH_SET_FILTERS,
  SEARCH_SET_QUERY, SEARCH_SET_RESULTS, SEARCH_UNSHIFT_SEARCHES,
} from './mutations.types'
import PowCustomerService from '../services/pow-customer.service'

const initialState = {
  query: '',
  results: [],
  searches: [],
  enabledFilters: {
    active: false,
    center: false,
    distance: false,
    radius: false,
    rates: false,
    tower: false,
    store: false,
    apType: false,
  },
  filters: {
    center: {
      lat: null,
      lng: null,
    },
    distance: null,
    distanceOp: '',
    active: {
      value: [],
    },
    apType: {
      value: [],
    },
    radius: {
      value: [],
    },
    rate_name: {
      value: [],
    },
    store: {
      value: [],
    },
    towerNumber: {
      value: [],
    },
  },
  useActive: false,
  useCache: false,
  useCenter: false,
  useDistance: false,
  useRates: false,
  distanceOperators: [
    {
      text: 'Less Than',
      value: 'lt',
    },
    {
      text: 'Greater Than',
      value: 'gt',
    },
  ],
  serviceRates: [
    'Video Streamer 10Mb/2Mb ( Powered by ezWave )',
    'Vega 15 ( 90 day promotional rate)',
    'Vega 15',
    'Vega 55 ( 90 day promotional rate )',
    'Vega 55',
    'Vega 105 ( 90 day promotional rate )',
    'Vega 105',
    'Select 2.5Mb/1Mb ( Powered by ezWave )',
    'No Worries Guarantee',
    'Nova Substation',
    'Vega Legacy 10',
    'Libre 105',
    'Residential Internet - 7 mbps ( 12 Month Promo )',
    'Residential Internet - 7 mbps',
    'Residential Internet - 21 mbps ( 12 month promo )',
    'Residential Internet - 21 mbps',
    'Economy 1.5Mb/1Mb',
    'Select 2.5Mb/1Mb',
    'Video Streamer 10Mb/2Mb',
    'Business Extreme',
    'Metro-10',
    'Metro-120',
  ],
  towerOptions: [
    '100',
    '100-epmp',
    '101',
    '102',
    '103',
    '104',
    '105',
    '105-epmp',
    '106',
    '107',
    '109',
    '110',
    '111',
    '112',
    '114',
    '115',
    '116-epmp',
    '117-epmp',
    '118-epmp',
    '212',
  ],
  activeOptions: [
    {
      text: 'Active',
      value: 'y',
    },
    {
      text: 'Suspended',
      value: 's',
    },
    {
      text: 'On Hold',
      value: 'h',
    },
    {
      text: 'Inactive',
      value: 'n',
    },
  ],
  storeOptions: [
    {
      text: 'Velociter',
      value: 1,
    },
    {
      text: 'ezWave',
      value: 2,
    },
  ],
  apTypeOptions: [
    {
      text: '450',
      value: '450',
    },
    {
      text: '450m',
      value: '450m',
    },
    {
      text: 'FSK',
      value: 'FSK',
    },
    {
      text: 'ePMP',
      value: 'ePMP',
    },
    {
      text: 'PTP',
      value: 'PTP',
    },
    {
      text: 'A5',
      value: 'A5',
    },
  ],
  radiusOptions: [
    '2.5/1',
    '2.5/1ab',
    '7/2',
    '10/2',
    '21/6',
    '25/5',
    'rural-15',
    'vega-15',
    'rural-55',
    'vega-55',
    'metro-10',
    'metro-120',
    'Economy',
    'Professional_3_2',
    'Express',
    'Express_2_0',
    'vega-105',
    'VIP-100',
    '50/50',
    '12/6',
    'VIP-100',
  ],
}
export const state = { ...initialState }

export const actions = {
  async [SEARCH_POST_QUERY] ({ dispatch, commit, rootState, state }, payload) {
    try {
      const calculatedPayload = {
        query: '',
        format: 'json',
        filters: {},
      }
      if (payload && payload.format) {
        calculatedPayload.format = payload.format
      }
      calculatedPayload.query = state.query
      if (state.useCache) {
        calculatedPayload.useCache = state.useCache
      }
      if (state.enabledFilters.distance) {
        calculatedPayload.filters.distance = state.filters.distance
        calculatedPayload.filters.distanceOp = state.filters.distanceOp
      }
      if (state.enabledFilters.center) {
        calculatedPayload.filters.center = state.filters.center
      }
      if (state.enabledFilters.rates) {
        calculatedPayload.filters.rate_name = state.filters.rate_name
      }
      if (state.enabledFilters.tower) {
        calculatedPayload.filters.towerNumber = state.filters.towerNumber
      }
      if (state.enabledFilters.active) {
        calculatedPayload.filters.active = state.filters.active
      }
      if (state.enabledFilters.store) {
        calculatedPayload.filters.store = state.filters.store
      }
      if (state.enabledFilters.apType) {
        calculatedPayload.filters.apType = state.filters.apType
      }
      if (state.enabledFilters.radius) {
        calculatedPayload.filters.radius = state.filters.radius
      }
      dispatch(_COMMIT_LOG, { message: 'Retrieving search results', calculatedPayload })
      const { data } = await PowCustomerService.searchCustomers(calculatedPayload)
      commit(SEARCH_SET_RESULTS, data)
      commit(SEARCH_UNSHIFT_SEARCHES, payload)
      return data
    } catch (e) {
      const processedError = await dispatch('processAxiosError', e)
      dispatch(_COMMIT_LOG, { message: 'Exception retrieving search results', error: processedError })
      return []
    }
  },
  // async [SEARCH_POST_QUERY_CSV] ({ dispatch, commit, rootState, state }, payload) {
  //   try {
  //     const calculatedPayload = {
  //       query: '',
  //       format: 'CSV',
  //       filters: {},
  //     }
  //     if (payload && payload.format) {
  //       calculatedPayload.format = payload.format
  //     }
  //     calculatedPayload.query = state.query
  //     if (state.useCache) {
  //       calculatedPayload.useCache = state.useCache
  //     }
  //     if (state.enabledFilters.distance) {
  //       calculatedPayload.filters.distance = state.filters.distance
  //       calculatedPayload.filters.distanceOp = state.filters.distanceOp
  //     }
  //     if (state.enabledFilters.center) {
  //       calculatedPayload.filters.center = state.filters.center
  //     }
  //     if (state.enabledFilters.rates) {
  //       calculatedPayload.filters.rate_name = state.filters.rate_name
  //     }
  //     if (state.enabledFilters.tower) {
  //       calculatedPayload.filters.towerNumber = state.filters.towerNumber
  //     }
  //     if (state.enabledFilters.active) {
  //       calculatedPayload.filters.active = state.filters.active
  //     }
  //     dispatch(_COMMIT_LOG, { message: 'Retrieving search results', calculatedPayload })
  //     let filename = 'cust-search_' + new Date().getTime()
  //     filename = filename.replace(/[/\\.]/g, '')
  //
  //     const { data } = await ApiService.postGetArray('pow-customer', 'search', calculatedPayload)
  //     const file = new File([data], filename, { lastModified: new Date().getTime(), type: 'application/csv' })
  //     const a = document.createElement('a')
  //     document.body.appendChild(a)
  //     const blobUrl = window.URL.createObjectURL(file)
  //     a.href = blobUrl
  //     a.download = filename
  //     a.click()
  //     setTimeout(() => {
  //       window.URL.revokeObjectURL(blobUrl)
  //       document.body.removeChild(a)
  //     }, 0)
  //
  //     return data
  //   } catch (e) {
  //     const processedError = await dispatch('processAxiosError', e)
  //     dispatch(_COMMIT_LOG, { message: 'Exception retrieving search results', error: processedError })
  //     return []
  //   }
  // },
}

export const mutations = {
  [SEARCH_SET_QUERY] (state, payload) {
    state.query = payload
  },
  [SEARCH_SET_RESULTS] (state, payload) {
    state.results = payload
  },
  [SEARCH_UNSHIFT_SEARCHES] (state, payload) {
    const searchHistory = Array(state.searches)
    state.searches = searchHistory.unshift(payload)
  },
  [SEARCH_SET_USE_CACHE] (state, payload) {
    state.useCache = payload
  },
  [SEARCH_SET_FILTERS] (state, payload) {
    state.filters = payload
  },
  [SEARCH_SET_ENABLED_FILTERS] (state, payload) {
    state.enabledFilters = payload
  },
}
export const getters = {
  search_filters: state => state.filters,
  search_query: state => state.query,
  search_results: state => state.results,
  search_searches: state => state.searches,
  search_useCache: state => state.useCache,
  search_enabledFilters: state => state.enabledFilters,
  search_distanceOperators: state => state.distanceOperators,
  search_serviceRates: state => state.serviceRates,
  search_towerOptions: state => state.towerOptions,
  search_activeOptions: state => state.activeOptions,
  search_storeOptions: state => state.storeOptions,
  search_apTypeOptions: state => state.apTypeOptions,
  search_radiusOptions: state => state.radiusOptions,
}
export default {
  state,
  actions,
  mutations,
  getters,
}
